module.exports = __webpack_public_path__ + "static/img/Logotipo_Positivo_Horizontal.fb53ae5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paginaoficial/Logotipo_Positivo_Horizontal.png
// module id = 0tmj
// module chunks = 2